import React, { useState, useCallback } from "react";
import PropTypes from "prop-types";
import { Button, Input, makeStyles } from "@fluentui/react-components";
import { FormattedMessage, useIntl } from "react-intl";
import { Modal } from "../modal/Modal";

const useStyles = makeStyles({
  textField: {
    width: "100%"
  }
});

export function RenameAssetDialog({ asset, open, onOpenChange, onSave, title }) {
  const intl = useIntl();
  const styles = useStyles();

  const [assetTitle, setAssetTitle] = useState(asset.title);

  const handleChangeTitle = useCallback(e => {
    setAssetTitle(e.target.value);
  }, []);

  const handleSave = () => {
    onOpenChange(null, { open: false });
    onSave({ id: asset.id, title: assetTitle });
  };

  const handleClose = () => {
    onOpenChange(null, { open: false });
  };

  const actions = (
    <>
      <Button appearance="outline" onClick={handleClose}>
        <FormattedMessage id="button.cancel" defaultMessage="Cancel" />
      </Button>
      <Button appearance="primary" onClick={handleSave} disabled={!assetTitle}>
        <FormattedMessage id="asset-editor.submit-button.save" defaultMessage="Save" />
      </Button>
    </>
  );

  return (
    <Modal title={title} open={open} onOpenChange={onOpenChange} onClose={handleClose} actions={actions}>
      <Input
        appearance="filled-darker"
        required
        value={assetTitle}
        onChange={handleChangeTitle}
        placeholder={intl.formatMessage({
          id: "asset-editor.field.asset-name",
          defaultMessage: "Asset name"
        })}
        className={styles.textField}
      />
    </Modal>
  );
}

RenameAssetDialog.propTypes = {
  asset: PropTypes.shape({
    id: PropTypes.string.isRequired,
    title: PropTypes.string.isRequired
  }).isRequired,
  open: PropTypes.bool,
  onOpenChange: PropTypes.func.isRequired,
  onSave: PropTypes.func.isRequired,
  title: PropTypes.string.isRequired
};
